import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
export var ClassAnnouncementRepository = /*#__PURE__*/function () {
  function ClassAnnouncementRepository(api) {
    _classCallCheck(this, ClassAnnouncementRepository);

    this.api = api;
  }

  _createClass(ClassAnnouncementRepository, [{
    key: "list",
    value: function list(classId, nextToken, limit) {
      return this.api.list(classId, nextToken, limit);
    }
  }, {
    key: "get",
    value: function get(classId, id) {
      return this.api.get(classId, id);
    }
  }, {
    key: "create",
    value: function create(classId, input) {
      return this.api.create(classId, input);
    }
  }, {
    key: "update",
    value: function update(classId, id, input) {
      return this.api.update(classId, id, input);
    }
  }, {
    key: "pin",
    value: function pin(classId, id, pinned, version) {
      return this.api.pin(classId, id, pinned, version);
    }
  }, {
    key: "delete",
    value: function _delete(classId, id, version) {
      return this.api["delete"](classId, id, version);
    }
  }]);

  return ClassAnnouncementRepository;
}();